import { useMutation, useQueryClient } from "@tanstack/react-query";
import { INVENTORY_KEYS } from "./keys";
import { inventoryService } from "./inventory.services";
import { v4 } from "uuid";

export const useCreateInventory = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: [INVENTORY_KEYS.INVENTORIES, "create"],
    mutationFn: (payload: any) => {
      // Check if payload is FormData (for CSV import)
      if (payload instanceof FormData) {
        const file = payload.get("file");
        if (file instanceof File && file.type === "text/csv") {
          return inventoryService.importInventories(payload);
        }
        return inventoryService.createInventory(payload);
      }
      // Use JSON endpoint for regular object payloads
      return inventoryService.createInventoryJson(payload);
    },
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [INVENTORY_KEYS.INVENTORIES],
      });
    },
  });
};

export const useUpdateInventory = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: [INVENTORY_KEYS.INVENTORIES, "update"],
    mutationFn: inventoryService.updateInventory,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [INVENTORY_KEYS.INVENTORIES],
      });
    },
  });
};

export const useEditInventory = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: [INVENTORY_KEYS.INVENTORIES, "edit"],
    mutationFn: inventoryService.updateInventory,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [INVENTORY_KEYS.INVENTORIES],
      });
    },
  });
};

export const useDeleteInventory = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: [INVENTORY_KEYS.INVENTORIES, "delete"],
    mutationFn: inventoryService.deleteInventory,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [INVENTORY_KEYS.INVENTORIES],
      });
    },
  });
};

export const useExportInventory = () => {
  return useMutation({
    mutationKey: [INVENTORY_KEYS.INVENTORIES, "export"],
    mutationFn: inventoryService.exportInventory,
    onSuccess: (data) => {
      const blob = new Blob([data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${v4()}-inventory.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
  });
};

export const useBulkUpdateInventory = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: [INVENTORY_KEYS.INVENTORIES, "bulk-update"],
    mutationFn: inventoryService.bulkUpdateInventory,
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [INVENTORY_KEYS.INVENTORIES],
      });
    },
  });
};
